import React, { Component } from 'react';
import CriteriaWidget from './CriteriaWidget';
import CriteriaMiniWidget from './CriteriaMiniWidget';
import ResultWidget from './ResultWidget';
import WidgetTitle from './WidgetTitle';
import CriteriaListWidget from './CriteriaListWidget';
import SectorPopup from './Components/PopupOverlay/SectorPopup';
import CompanyScorePopup from './Components/PopupOverlay/CompanyScorePopup';
import CompanyInfoPopup from './Components/PopupOverlay/CompanyInfoPopup';
import AdvCriteriaPopup from './Components/PopupOverlay/AdvCriteriaPopup';
import Config from './Configs/criteria.json';
import './Screener.css';
import PresetWidget from './PresetWidget';
import axios from 'axios';
import MyScreenerPopup from './Components/PopupOverlay/MyScreenerPopup';
import cookie from 'react-cookies'
import qs from 'qs'
import refinitivlogo from './img/refinitiv.png';
import ReactDOM from 'react-dom';
const debounce = (fn, delay) => {
    let timer = null;
    return function (...args) {
        const context = this;
        timer && clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    };
}
const CancelToken = axios.CancelToken;
const { detect } = require('detect-browser');
const browser = detect();
let cancel;
let cookiePath = "/"
export default class Screener extends Component {
    constructor(props) {
        if (browser) {
            if (browser.name === "ie" && browser.os === "Windows 7") {
                cookiePath = "/"
            }
            else {
                cookiePath = process.env.REACT_APP_ROUTER_BASE || "/"
            }
        }
        super(props);
        this.setState({ fromPreset: false });
        let market = [];
        this.marketLookup = [];
        for (let i = 0; i < Config.criteria.market.length; i++) {
            market[i] = false;
            this.marketLookup[Config.criteria.market[i].resultid] = i;
        }
        let capsize = [];
        this.capsizeLookup = [];
        for (let i = 0; i < Config.criteria.capsize.length; i++) {
            capsize[i] = false;
            this.capsizeLookup[Config.criteria.capsize[i].resultid] = i;
        }
        let index = [];
        this.indexLookup = [];
        for (let i = 0; i < Config.criteria.index.length; i++) {
            index[i] = false;
            this.indexLookup[Config.criteria.index[i].resultid] = i;
        }
        let sector = [];
        this.sectorLookup = [];
        for (let i = 0; i < Config.criteria.sector.length; i++) {
            sector[i] = false;
            this.sectorLookup["cs" + Config.criteria.sector[i].id] = i;
        }
        let nisa = [];
        this.nisaLookup = [];
        for (let i = 0; i < Config.criteria.nisa.length; i++) {
            nisa[i] = false;
            this.nisaLookup[Config.criteria.nisa[i].resultid] = i;
        }
        let bullbear = [];
        this.bullbearLookup = [];
        for (let i = 0; i < Config.criteria.bullbear.length; i++) {
            bullbear[i] = false;
            this.bullbearLookup[Config.criteria.bullbear[i].resultid] = i;
        }
        let score = [];
        for (let i = 0; i < Config.criteria.score.length; i++) {
            score[i] = { disabled: true, value: [0, 10] };
        }
        let investamt = [];
        let advanced = [];
        this.advancedLookup = [];
        this.advancedOptvalueLookup = [];
        this.advancedOptvalue2Lookup = [];
        Object.keys(Config.criteria.advanced).forEach((key) => {
            advanced[key] = [];
            for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                advanced[key][i] = {
                    selected: false,
                    option: 0,
                    option2: 0,
                    lower: -9999999999,
                    upper: 9999999999,
                    enabled: true,
                    refreshSnap: true,
                    monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                };
                if (key === "consensus" && i === 28) {
                    advanced[key][i] = {
                        selected: false,
                        option: 0,
                        option2: 0,
                        lower: 1,
                        upper: 5,
                        enabled: true,
                        refreshSnap: true,
                        monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                    };
                }
                this.advancedLookup["ca" + Config.criteria.advanced[key][i].id] = { type: key, pos: i };

                if (Config.criteria.advanced[key][i].optvalue) {
                    this.advancedOptvalueLookup["ca" + Config.criteria.advanced[key][i].id] = [];
                    for (let j = 0; j < Config.criteria.advanced[key][i].optvalue.length; j++) {
                        this.advancedOptvalueLookup["ca" + Config.criteria.advanced[key][i].id][Config.criteria.advanced[key][i].optvalue[j]] = j;
                    }
                }
                if (Config.criteria.advanced[key][i].optvalue2) {
                    this.advancedOptvalue2Lookup["ca" + Config.criteria.advanced[key][i].id] = []
                    for (let j = 0; j < Config.criteria.advanced[key][i].optvalue2.length; j++) {
                        this.advancedOptvalue2Lookup["ca" + Config.criteria.advanced[key][i].id][Config.criteria.advanced[key][i].optvalue2[j]] = j;
                    }
                }
            }
        });
        // let presetscreener = [];
        let myscreener = [];
        let savedUserScr_local = localStorage.getItem('SBI_JP_SCR_USCR');
        let savedUserScr = cookie.load("USCR");
        if (!savedUserScr_local) {
            if (!savedUserScr) {
                for (let i = 0; i < Config.myscreener.maxnum; i++) {
                    myscreener[i] = { name: "", criteria: "", sortby: "", sortorder: "" };
                }
                localStorage.setItem('SBI_JP_SCR_USCR', encodeURI(JSON.stringify(myscreener)))
                // document.cookie = "USCR=" + encodeURI(JSON.stringify(myscreener)) + ";expires=" + this.getCookieExpiresDate().toUTCString() + ";path=" + cookiePath+";SameSite=None; Secure";
                // cookie.save("USCR", myscreener, { path: process.env.REACT_APP_ROUTER_BASE, expires:this.getCookieExpiresDate().toUTCString(),maxAge:Config.myscreener.maxAge });
            } else {
                localStorage.setItem('SBI_JP_SCR_USCR', encodeURI(JSON.stringify(savedUserScr)))
                myscreener = savedUserScr;
            }
        } else {
            myscreener = JSON.parse(decodeURI(savedUserScr_local))
        }
        let myscreenermemo = [];
        let savedUserScrMemo_local = localStorage.getItem('SBI_JP_SCR_USCRMEMO');
        let savedUserScrMemo = cookie.load("USCRMEMO");
        if (!savedUserScrMemo_local) {
            if (!savedUserScrMemo) {
                for (let i = 0; i < Config.myscreener.maxnum; i++) {
                    myscreenermemo[i] = { name: "", criteria: "" };
                }
                localStorage.setItem('SBI_JP_SCR_USCRMEMO', encodeURI(JSON.stringify(myscreenermemo)))
                // document.cookie = "USCRMEMO=" + encodeURI(JSON.stringify(myscreenermemo)) + ";expires=" + this.getCookieExpiresDate().toUTCString() + ";path=" + cookiePath+";SameSite=None; Secure";
                // cookie.save("USCRMEMO", myscreenermemo, { path: process.env.REACT_APP_ROUTER_BASE, expires:this.getCookieExpiresDate().toUTCString(),maxAge:Config.myscreener.maxAge }); 
            } else {
                localStorage.setItem('SBI_JP_SCR_USCRMEMO', encodeURI(JSON.stringify(savedUserScrMemo)))
                myscreenermemo = savedUserScrMemo;
            }
        } else {
            myscreenermemo = JSON.parse(decodeURI(savedUserScrMemo_local));
        }

        let savedShowSearchPage_local = localStorage.getItem('SBI_JP_SCR_FV');
        let savedShowSearchPage = cookie.load("FV");
        if (!savedShowSearchPage_local) {
            if (!savedShowSearchPage) {
                this.setState({ savedShowSearchPage: true });
                savedShowSearchPage = "true";
                savedShowSearchPage_local= "true"
                localStorage.setItem('SBI_JP_SCR_FV', "true")
                // document.cookie = "FV=true; expires=" + this.getCookieExpiresDate().toUTCString() + ";path=" + cookiePath+";SameSite=None; Secure";;
                // cookie.save("FV", true, { path: process.env.REACT_APP_ROUTER_BASE, expires:this.getCookieExpiresDate().toUTCString(),maxAge:Config.myscreener.maxAge });
            } else {
                //console.log("111:" + savedShowSearchPage);
                this.setState({ savedShowSearchPage: savedShowSearchPage === "true" ? true : false });
            }
        } else {
            this.setState({ savedShowSearchPage: savedShowSearchPage_local === "true" ? true : false });
        }
        this.appId = qs.parse(props.location.search, { ignoreQueryPrefix: true }).appId
        if (!this.appId) {
            this.appId = "PC"
        }
        // for (let i=0; i<Config.presetscreener.maxnum; i++) {
        //     presetscreener[i] = { name: "", count: "", criteria: []};
        // }

        this.state = {
            criteria: {
                market,
                capsize,
                sector,
                index,
                score,
                nisa,
                bullbear,
                advanced: {
                    financial: advanced["financial"],
                    consensus: advanced["consensus"],
                    priceperf: advanced["priceperf"],
                    technical: advanced["technical"],
                    other: advanced["other"]
                },
                investamt
            },
            criteriaSnap: {
                market,
                capsize,
                sector: [...sector],
                index,
                score: [...score],
                nisa,
                bullbear,
                advanced: {
                    financial: [...advanced["financial"]],
                    consensus: [...advanced["consensus"]],
                    priceperf: [...advanced["priceperf"]],
                    technical: [...advanced["technical"]],
                    other: [...advanced["other"]]
                },
                investamt
            },
            //   presetscreener,
            myscreener,
            myscreenermemo,
            result: {},
            resultSnap: {},
            advancedQueue: [],
            showSearchResult: false,
            showPopup: "",
            recperpage: 50,
            pageno: 1,
            sortby: "c",
            sortorder: "asc",
            isLoading: false,
            myScrResultHidden: true,
            myScrResearchHidden: false,
            savebtnStyleName: "screenersavebtn",
            savebtnName: "Myスクリーナーに保存",
            compInfo: [],
            x: 0, y: 0,
            presetSelected: "p01",
            savedShowSearchPage: savedShowSearchPage === "true" ? true : false,
            fristLogin: true,
            showErrMsg: "off",
            section: "preset",
            leftArrowSelected: false,
            scrollXPos: 0,
            acSelectedCount: 0,
            fromPreset: false,
            presetString: "",
            appId: this.appId

        };

        this.token = qs.parse(props.location.search, { ignoreQueryPrefix: true }).token;
        this.preset = qs.parse(props.location.search, { ignoreQueryPrefix: true }).preset;


        // console.log( this.token)
        // console.log( "token=" + this.token + ";path=" + cookiePath+";SameSite=None; Secure")

        // console.log(browser.name);
        // console.log(browser.version);
        // console.log(browser.os);
        localStorage.setItem('SBI_JP_SCR_TOKEN', this.token)
        // document.cookie = "token=" + this.token + ";expires=" + this.getCookieExpiresDate().toUTCString() + ";path=" + cookiePath + ";SameSite=None; Secure";

        // cookie.save("token", this.token, { path: process.env.REACT_APP_ROUTER_BASE });

        // //console.log("aaa:"+this.state.criteria.advanced.other[0].monthChecked);
        this.getScreenerResult = debounce(this.getScreenerResult, 500);


    }
    handleSelectionBoxChange = (name, value, ischecked, refreshSnap) => {
        console.log(name, value, ischecked, refreshSnap)
        this.criteria = this.state.criteria;
        this.criteria[name][value] = ischecked;
        this.setState({ criteria: this.criteria });
        if (refreshSnap) {
            this.setState({ criteriaSnap: JSON.parse(JSON.stringify(this.criteria)) });
        }
        this.getScreenerResult(refreshSnap);
        // //console.log("Fetch Results After Selection Box Changed");
    }
    handleCriteriaBoxChange = (name, value, criteriavalues, cb) => {
        this.criteria = this.state.criteria;
        if (this.getNumberOfSelectedItem() < 10 || !criteriavalues.selected || this.criteria.advanced[name][value].selected) {
            if (!this.criteria.advanced[name][value].selected && criteriavalues.selected) {
                this.criteria.advanced[name][value] = criteriavalues;
                let aq = [];
                Object.keys(Config.criteria.advanced).forEach((key) => {
                    for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                        if (this.criteria.advanced[key][i].selected) {
                            aq.push({ key, i });
                        }
                    }
                });
                this.setState({ advancedQueue: aq });
            }
            this.criteria.advanced[name][value] = criteriavalues;
            this.setState({ criteria: this.criteria }, cb);
            //console.log(criteriavalues);
            if (criteriavalues.refreshSnap) {
                this.setState({ criteriaSnap: JSON.parse(JSON.stringify(this.criteria)) });
            }
            if (!criteriavalues.selected) {
                let aq = [];
                if (criteriavalues.refreshSnap) { // override usage: use refreshSnap to distinquish whether the request is from result or off result view
                    aq = this.state.advancedQueue;
                    for (let i = 0; i < aq.length; i++) {
                        if (aq[i].key === name && aq[i].i === value) {
                            aq.splice(i, 1);
                            i--;
                        }
                    }
                } else {
                    Object.keys(Config.criteria.advanced).forEach((key) => {
                        for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                            if (this.criteria.advanced[key][i].selected) {
                                aq.push({ key, i });
                            }
                        }
                    });
                }
                this.setState({ advancedQueue: aq });
            }

            // if(enabled){}
            this.getScreenerResult(criteriavalues.refreshSnap);
            // //console.log("Fetch Results After Criteria Box Changed");

            this.setState({ showErrMsg: "off" });
        } else {
            this.setState({ showErrMsg: "on" });
        }
    }
    handleChange = (checked, fromCust, fromPreset) => {
        if (this.state.recperpage === 10) {
            this.setState({ recperpage: 50, pageno: 1 });
        }
        if (fromPreset) {
            this.setState({ fromPreset: true });
        }
        if (this.state.fristLogin) {
            if (this.state.savedShowSearchPage) {
                this.setState({ showSearchResult: false, myScrResultHidden: true, myScrResearchHidden: false });
            } else {
                this.setState({ showSearchResult: true, myScrResultHidden: false, myScrResearchHidden: true });
            }
            this.setState({ fristLogin: false }, () => {
                this.getScreenerResult(true, fromCust, this.state.fromPreset);
            });
            // cookie.save("FV", this.state.savedShowSearchPage, { path: process.env.REACT_APP_ROUTER_BASE, expires:this.getCookieExpiresDate().toUTCString(),maxAge:Config.myscreener.maxAge });
        } else {
            this.setState({ savedShowSearchPage: checked, showSearchResult: checked, myScrResultHidden: !checked, myScrResearchHidden: checked }, () => {
                if (checked) {
                    this.setState({ criteriaSnap: JSON.parse(JSON.stringify(this.state.criteria)) }, () => {
                        this.getScreenerResult(true, fromCust, this.state.fromPreset);
                    });
                }
            });
            localStorage.setItem('SBI_JP_SCR_FV', !checked )
            // document.cookie = "FV=" + !checked + "; expires=" + this.getCookieExpiresDate().toUTCString() + ";path=" + cookiePath + ";SameSite=None; Secure";
            // cookie.save("FV", !checked, { path: process.env.REACT_APP_ROUTER_BASE, expires:this.getCookieExpiresDate().toUTCString(),maxAge:Config.myscreener.maxAge });
        }
        // this.setState({savedShowSearchPage:checked, showSearchResult: checked, myScrResultHidden: !checked, myScrResearchHidden: checked });



    }
    handlePopupChange = (id) => {
        this.setState({ showPopup: id });
        // var rect = this.getBoundingClientRect();
        // //console.log(rect.scrollTop);
        //console.log("X:" + window.pageXOffset + "|Y:" + window.pageYOffset);
        // window.scrollTo(0, window.pageYOffset);

    }
    handleCompInfoPopupChange = (id, header, info, num) => {
        this.setState({ showPopup: id, compInfo: [header, info, num] });
    }
    handleSectorSubmit = (sector) => {
        this.criteria = this.state.criteria;
        this.criteria.sector = sector;
        this.setState({ criteria: this.criteria });
        this.setState({ criteriaSnap: JSON.parse(JSON.stringify(this.criteria)) });
        this.getScreenerResult(true);
        // //console.log("Fetch Results After Sector Submit");
    }
    handleScoreSubmit = (score) => {
        this.criteria = this.state.criteria;
        this.criteria.score = score;
        this.setState({ criteria: this.criteria });
        this.setState({ criteriaSnap: JSON.parse(JSON.stringify(this.criteria)) });
        this.getScreenerResult(true);
        // //console.log("Fetch Results After Score Submit");
    }
    handleAdvCriteriaSubmit = (advanced) => {
        this.criteria = this.state.criteria;
        this.criteria.advanced = advanced;
        this.setState({ criteria: this.criteria });
        this.setState({ criteriaSnap: JSON.parse(JSON.stringify(this.criteria)) });

        let aq = [];
        Object.keys(Config.criteria.advanced).forEach((key) => {
            for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                if (this.criteria.advanced[key][i].selected) {
                    aq.push({ key, i });
                }
            }
        });
        this.setState({ advancedQueue: aq });
        this.getScreenerResult(true);
        // //console.log("Fetch Results After Adv Criteria Submit");
    }
    closePopupHandler = () => {
        this.setState({ showPopup: "" });
    }
    handleSelectAllMarket = (refreshSnap) => {
        this.criteria = this.state.criteria;
        let market = this.criteria.market;
        let checked = true;
        if (this.isSelectAllMarketChecked()) {
            checked = false;
        }
        for (let i = 0; i < market.length; i++) {
            market[i] = checked;
        }
        this.setState({ criteria: this.criteria });
        if (refreshSnap) {
            this.setState({ criteriaSnap: JSON.parse(JSON.stringify(this.criteria)) });
        }
        this.getScreenerResult();
        // //console.log("Fetch Results After Select All Market");
    }
    isSelectAllMarketChecked = () => {
        for (let i = 0; i < this.state.criteria.market.length; i++) {
            if (this.state.criteria.market[i] === false) {
                return false;
            }
        }
        return true;
    }
    handleSelectAllSector = () => {
        this.criteria = this.state.criteria;
        let sector = this.criteria.sector;
        let checked = true;
        if (this.isSelectAllSectorChecked()) {
            checked = false;
        }
        for (let i = 0; i < sector.length; i++) {
            sector[i] = checked;
        }
        this.setState({ criteria: this.criteria });
        this.getScreenerResult();
        // //console.log("Fetch Results After Select All Sector");
    }
    isSelectAllSectorChecked = () => {
        for (let i = 0; i < this.state.criteria.sector.length; i++) {
            if (this.state.criteria.sector[i] === false) {
                return false;
            }
        }
        return true;
    }
    handleScoreBoxChange = (index, disabled, value) => {
        this.criteria = this.state.criteria;
        let score = this.criteria.score;
        score[index] = { disabled, value };
        this.setState({ criteria: this.criteria });
        this.getScreenerResult();
        // //console.log("Fetch Results After Score Box Changed");
    }
    handleInvestAmtChange = (investamt, refreshSnap) => {
        this.criteria = this.state.criteria;
        this.criteria.investamt = investamt;
        this.setState({ criteria: this.criteria });
        if (refreshSnap) {
            this.setState({ criteriaSnap: JSON.parse(JSON.stringify(this.criteria)) });
        }
        this.getScreenerResult(refreshSnap);
        // //console.log("Fetch Results After Invest Amt Changed");
    }
    handleRecPerPageChange = (recperpage, fromPreset) => {
        // if(fromPreset){
        //     this.setState({fromPreset:true});
        // }
        this.setState({ recperpage, pageno: 1 }, () => { this.getScreenerResult(true) });
    }
    handlePageChange = (pageno, fromPreset) => {
        // if(fromPreset){
        //     this.setState({fromPreset:true});
        // }
        this.setState({ pageno }, () => { this.getScreenerResult(true, true) });
    }
    handleSaveScreener = (num, name, memo) => {
        this.screener = this.state.myscreener;
        this.screener[num] = { name, criteria: this.getCriteraRequestString(), sortby: this.state.sortby, sortorder: this.state.sortorder };
        this.screenermemo = this.state.myscreenermemo;
        this.screenermemo[num] = { name, criteria: memo };
        this.setState({ myscreener: this.screener, myscreenermemo: this.screenermemo }, () => { this.closePopupHandler() });
        localStorage.setItem('SBI_JP_SCR_USCR', encodeURI(JSON.stringify(this.screener)))
        localStorage.setItem('SBI_JP_SCR_USCRMEMO', encodeURI(JSON.stringify(this.screenermemo)))
        // document.cookie = "USCR=" + encodeURI(JSON.stringify(this.screener)) + ";expires=" + this.getCookieExpiresDate().toUTCString() + ";path=" + cookiePath + ";SameSite=None; Secure";
        // document.cookie = "USCRMEMO=" + encodeURI(JSON.stringify(this.screenermemo)) + ";expires=" + this.getCookieExpiresDate().toUTCString() + ";path=" + cookiePath + ";SameSite=None; Secure";
        // cookie.save("USCR", this.screener, { path: process.env.REACT_APP_ROUTER_BASE, expires:this.getCookieExpiresDate().toUTCString(),maxAge:Config.myscreener.maxAge });
        // cookie.save("USCRMEMO", this.screenermemo, { path: process.env.REACT_APP_ROUTER_BASE, expires:this.getCookieExpiresDate().toUTCString(),maxAge:Config.myscreener.maxAge });
        let tmpleftArrowSelected = false;
        if ((num + 1) > 4) {
            tmpleftArrowSelected = true;
            this.setState({ scrollXPos: -(238 * 2 - 22) });
        } else {
            if (!tmpleftArrowSelected && this.state.scrollXPos < 0) {
                tmpleftArrowSelected = false;
                this.setState({ scrollXPos: this.state.scrollXPos + (238 * 2 - 22) });
            }
        }
        this.setState({ section: "custom", savebtnStyleName: "screenersavedbtn", savebtnName: "Myスクリーナーに登録済", presetSelected: "c0" + (num + 1), leftArrowSelected: tmpleftArrowSelected });
    }
    handleSection = (section) => {
        this.setState({ section: section });
    }
    handlePresetScreenerLoading = (criteria, id, sortby, sortorder) => {
        // //console.log("handlePresetScreenerLoading");
        if (criteria) {
            //market
            let market = [];
            for (let i = 0; i < Config.criteria.market.length; i++) {
                market[i] = false;
            }
            for (let i = 0; i < criteria.market.length; i++) {
                market[this.marketLookup[criteria.market[i]]] = true;
            }
            //capsize
            let capsize = [];
            for (let i = 0; i < Config.criteria.capsize.length; i++) {
                capsize[i] = false;
            }
            for (let i = 0; i < criteria.capsize.length; i++) {
                capsize[this.capsizeLookup[criteria.capsize[i]]] = true;
            }
            //index
            let index = [];
            for (let i = 0; i < Config.criteria.index.length; i++) {
                index[i] = false;
            }
            for (let i = 0; i < criteria.index.length; i++) {
                index[this.indexLookup[criteria.index[i]]] = true;
            }
            //sector
            let sector = [];
            for (let i = 0; i < Config.criteria.sector.length; i++) {
                sector[i] = false;
            }
            for (let i = 0; i < criteria.sector.length; i++) {
                sector[this.sectorLookup[criteria.sector[i]]] = true;
            }
            //nisa
            let nisa = [];
            for (let i = 0; i < Config.criteria.nisa.length; i++) {
                nisa[i] = false;
            }
            for (let i = 0; i < criteria.nisa.length; i++) {
                nisa[this.nisaLookup[criteria.nisa[i]]] = true;
            }
            //flag
            let bullbear = [];
            for (let i = 0; i < Config.criteria.bullbear.length; i++) {
                bullbear[i] = false;
            }
            for (let i = 0; i < criteria.bullbear.length; i++) {
                bullbear[this.bullbearLookup[criteria.bullbear[i]]] = true;
            }
            //score
            let score = [];
            for (let i = 0; i < Config.criteria.score.length; i++) {
                score[i] = { disabled: true, value: [0, 10] };
                if (criteria["rating" + (i + 1)]) {
                    score[i] = { disabled: criteria["rating" + (i + 1)].add === 1, value: [criteria["rating" + (i + 1)].from, criteria["rating" + (i + 1)].to] };
                }
            }
            //invest
            let investamt = [-1, -1];
            if (!criteria.invest.isany) {
                investamt = [criteria.invest.from, criteria.invest.to];
            }

            this.criteria = this.state.criteria;

            let advanced = [];
            this.advancedLookup = [];
            this.advancedOptvalueLookup = [];
            this.advancedOptvalue2Lookup = [];
            Object.keys(Config.criteria.advanced).forEach((key) => {
                advanced[key] = [];
                for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                    advanced[key][i] = {
                        selected: false,
                        option: 0,
                        option2: 0,
                        lower: -9999999999,
                        upper: 9999999999,
                        enabled: true,
                        refreshSnap: true,
                        monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                    };
                    if (key === "consensus" && i === 28) {
                        // console.log("found sup")
                        advanced[key][i] = {
                            selected: false,
                            option: 0,
                            option2: 0,
                            lower: 1,
                            upper: 5,
                            enabled: true,
                            refreshSnap: true,
                            monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                        };
                    }
                    this.advancedLookup["ca" + Config.criteria.advanced[key][i].id] = { type: key, pos: i };

                    if (Config.criteria.advanced[key][i].optvalue) {
                        this.advancedOptvalueLookup["ca" + Config.criteria.advanced[key][i].id] = [];
                        for (let j = 0; j < Config.criteria.advanced[key][i].optvalue.length; j++) {
                            this.advancedOptvalueLookup["ca" + Config.criteria.advanced[key][i].id][Config.criteria.advanced[key][i].optvalue[j]] = j;
                        }
                    }
                    if (Config.criteria.advanced[key][i].optvalue2) {
                        this.advancedOptvalue2Lookup["ca" + Config.criteria.advanced[key][i].id] = []
                        for (let j = 0; j < Config.criteria.advanced[key][i].optvalue2.length; j++) {
                            this.advancedOptvalue2Lookup["ca" + Config.criteria.advanced[key][i].id][Config.criteria.advanced[key][i].optvalue2[j]] = j;
                        }
                    }
                }
            });

            this.setState({
                criteria: {
                    market,
                    capsize,
                    sector,
                    index,
                    nisa,
                    bullbear,
                    score,
                    advanced: {
                        financial: advanced["financial"],
                        consensus: advanced["consensus"],
                        priceperf: advanced["priceperf"],
                        technical: advanced["technical"],
                        other: advanced["other"]
                    },
                    investamt
                },
                criteriaSnap: {
                    market,
                    capsize,
                    sector: [...sector],
                    index,
                    nisa,
                    bullbear,
                    score: [...score],
                    advanced: {
                        financial: [...advanced["financial"]],
                        consensus: [...advanced["consensus"]],
                        priceperf: [...advanced["priceperf"]],
                        technical: [...advanced["technical"]],
                        other: [...advanced["other"]]
                    },
                    investamt
                }
            }, () => {
                //advanced criteria
                Object.keys(Config.criteria.advanced).forEach((key) => {
                    for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                        this.criteria.advanced[key][i] = {
                            selected: false,
                            option: 0,
                            option2: 0,
                            lower: -9999999999,
                            upper: 9999999999,
                            enabled: true,
                            refreshSnap: true,
                            monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                        };
                        if (key === "consensus" && i === 28) {
                            // console.log("found sup")
                            advanced[key][i] = {
                                selected: false,
                                option: 0,
                                option2: 0,
                                lower: 1,
                                upper: 5,
                                enabled: true,
                                refreshSnap: true,
                                monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                            };
                        }
                    }
                });

                let aq = [];
                for (let i = 0; i < criteria.advanced.length; i++) {
                    let tmpmonthChecked = [false, false, false, false, false, false, false, false, false, false, false, false];
                    let tmpmonthStr = null;
                    if (criteria.advanced[i].month) {
                        tmpmonthStr = "";
                        for (let n = 0; n < criteria.advanced[i].month.length; n++) {
                            tmpmonthChecked[criteria.advanced[i].month[n] - 1] = true;
                            tmpmonthStr += criteria.advanced[i].month[n] + "m";
                        }
                    }
                    let advanced = {
                        selected: true,
                        option: criteria.advanced[i].type ? this.advancedOptvalueLookup[criteria.advanced[i].id][criteria.advanced[i].type] : 0,
                        option2: criteria.advanced[i].type2 ? this.advancedOptvalue2Lookup[criteria.advanced[i].id][criteria.advanced[i].type2] : 0,
                        lower: tmpmonthStr !== null ? tmpmonthStr : criteria.advanced[i].from,
                        upper: criteria.advanced[i].to,
                        enabled: true,
                        refreshSnap: true,
                        monthChecked: tmpmonthChecked
                    }
                    // console.log("preset type:" + advanced.type)
                    this.criteria.advanced[this.advancedLookup[criteria.advanced[i].id].type][this.advancedLookup[criteria.advanced[i].id].pos] = advanced;
                    aq.push({ key: this.advancedLookup[criteria.advanced[i].id].type, i: this.advancedLookup[criteria.advanced[i].id].pos });
                }

                this.criteria.market = market;
                this.criteria.capsize = capsize;
                this.criteria.index = index;
                this.criteria.sector = sector;
                this.criteria.nisa = nisa;
                this.criteria.bullbear = bullbear;
                this.criteria.score = score;
                this.criteria.investamt = investamt;
                this.setState({ pageno: 1, sortby: sortby, sortorder: sortorder, criteria: this.criteria }, () => {
                    this.setState({ criteriaSnap: JSON.parse(JSON.stringify(this.state.criteria)), presetSelected: id, advancedQueue: aq }, () => {

                        this.handleChange(true, true, false);

                    });
                    // this.getScreenerResult(true);

                }
                );

            }
            );




        }
        //  //console.log("id:"+id);
    }
    handleCustomScreenerLoading = (num, id) => {
        let targetscr = this.state.myscreener[num];
        let criteria = targetscr.criteria;

        //sorting
        let sortby = targetscr.sortby;
        let sortorder = targetscr.sortorder;
        if (!sortby || sortby === "") {
            sortby = "c"
            sortorder = "asc";
        }
        //console.log(targetscr);
        //initialization
        let market = [];
        let capsize = [];
        let index = [];
        let nisa = [];
        let bullbear = [];
        let investamt = [-1, -1];
        let sector = [];
        let score = [];
        this.criteria = this.state.criteria;
        for (let i = 0; i < Config.criteria.score.length; i++) {
            score[i] = { disabled: true, value: [0, 10] };
        }
        let advanced = [];
        this.advancedLookup = [];
        this.advancedOptvalueLookup = [];
        this.advancedOptvalue2Lookup = [];
        Object.keys(Config.criteria.advanced).forEach((key) => {
            advanced[key] = [];
            for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                advanced[key][i] = {
                    selected: false,
                    option: 0,
                    option2: 0,
                    lower: -9999999999,
                    upper: 9999999999,
                    enabled: true,
                    refreshSnap: true,
                    monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                };
                if (key === "consensus" && i === 28) {
                    advanced[key][i] = {
                        selected: false,
                        option: 0,
                        option2: 0,
                        lower: 1,
                        upper: 5,
                        enabled: true,
                        refreshSnap: true,
                        monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                    };
                }
                this.advancedLookup["ca" + Config.criteria.advanced[key][i].id] = { type: key, pos: i };

                if (Config.criteria.advanced[key][i].optvalue) {
                    this.advancedOptvalueLookup["ca" + Config.criteria.advanced[key][i].id] = [];
                    for (let j = 0; j < Config.criteria.advanced[key][i].optvalue.length; j++) {
                        this.advancedOptvalueLookup["ca" + Config.criteria.advanced[key][i].id][Config.criteria.advanced[key][i].optvalue[j]] = j;
                    }
                }
                if (Config.criteria.advanced[key][i].optvalue2) {
                    this.advancedOptvalue2Lookup["ca" + Config.criteria.advanced[key][i].id] = []
                    for (let j = 0; j < Config.criteria.advanced[key][i].optvalue2.length; j++) {
                        this.advancedOptvalue2Lookup["ca" + Config.criteria.advanced[key][i].id][Config.criteria.advanced[key][i].optvalue2[j]] = j;
                    }
                }
            }
        });

        this.setState({
            criteria: {
                market,
                capsize,
                sector,
                index,
                nisa,
                bullbear,
                score,
                advanced: {
                    financial: advanced["financial"],
                    consensus: advanced["consensus"],
                    priceperf: advanced["priceperf"],
                    technical: advanced["technical"],
                    other: advanced["other"]
                },
                investamt
            },
            criteriaSnap: {
                market,
                capsize,
                sector: [...sector],
                index,
                nisa,
                bullbear,
                score: [...score],
                advanced: {
                    financial: [...advanced["financial"]],
                    consensus: [...advanced["consensus"]],
                    priceperf: [...advanced["priceperf"]],
                    technical: [...advanced["technical"]],
                    other: [...advanced["other"]]
                },
                investamt
            }
        }, () => {


            Object.keys(Config.criteria.advanced).forEach((key) => {
                for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                    if (key === "consensus" && i === 28) {
                        // console.log("found sup")
                        this.criteria.advanced[key][i] = {
                            selected: false,
                            option: 0,
                            option2: 0,
                            lower: 1,
                            upper: 5,
                            enabled: true,
                            refreshSnap: true,
                            monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                        };
                    } else {
                        this.criteria.advanced[key][i] = {
                            selected: false,
                            option: 0,
                            option2: 0,
                            lower: -9999999999,
                            upper: 9999999999,
                            enabled: true,
                            refreshSnap: true,
                            monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                        };
                    }


                }
            });
            let aq = [];

            let cary = criteria.split(",");
            for (let i = 0; i < cary.length; i++) {
                let copt = cary[i].substr(0, 2);
                let ccontent = cary[i].substr(2);

                if (copt === "m:") { //market
                    for (let i = 0; i < Config.criteria.market.length; i++) {
                        market[i] = false;
                        for (let x = 0; x < ccontent.length; x++) {
                            if(Config.criteria.market[i].id===ccontent.substr(x, 1)){
                                market[i] = true;
                                break;
                            }
                        }
                    }
                    
                } else if (copt === "c:") { //capsize
                    for (let i = 0; i < Config.criteria.capsize.length; i++) {
                        capsize[i] = false;
                    }
                    for (let i = 0; i < ccontent.length; i++) {
                        capsize[ccontent.substr(i, 1)] = true;
                    }
                } else if (copt === "i:") { //index
                    for (let i = 0; i < Config.criteria.index.length; i++) {
                        index[i] = false;
                    }
                    for (let i = 0; i < ccontent.length; i++) {
                        index[ccontent.substr(i, 1)] = true;
                    }
                } else if (copt === "s:") { //sector
                    for (let i = 0; i < Config.criteria.sector.length; i++) {
                        sector[i] = false;
                    }
                    for (let i = 0; i < ccontent.length / 3; i++) {
                        let sstr = "cs" + ccontent.substr(i + i * 2, 3);
                        if (this.sectorLookup[sstr] != null) {
                            sector[this.sectorLookup[sstr]] = true;
                        }
                    }
                } else if (copt === "n:") { //nisa
                    for (let i = 0; i < Config.criteria.nisa.length; i++) {
                        nisa[i] = false;
                    }
                    for (let i = 0; i < ccontent.length; i++) {
                        nisa[ccontent.substr(i, 1)] = true;
                    }
                } else if (copt === "b:") { //bullbear
                    for (let i = 0; i < Config.criteria.bullbear.length; i++) {
                        bullbear[i] = false;
                    }
                    for (let i = 0; i < ccontent.length; i++) {
                        bullbear[ccontent.substr(i, 1)] = true;
                    }
                }  else if (copt === "a:") { //investamt
                    let val = ccontent.split("|");
                    if (val.length >= 3) {
                        if (val[0] === "0") {
                            investamt[0] = val[1] === "0" ? -1 : val[1];
                            investamt[1] = val[2] === "0" ? -1 : val[2];
                        }
                    }
                }
                copt = cary[i].substr(0, 3);
                ccontent = cary[i].substr(3);
                if (copt === "r1:") {
                    let val = ccontent.split("|");
                    if (val.length >= 3) {
                        score[0] = { disabled: val[2] === "1", value: [val[0], val[1]] };
                    } else {
                        score[0] = { disabled: true, value: [0, 10] };
                    }
                } else if (copt === "r2:") {
                    let val = ccontent.split("|");
                    if (val.length >= 3) {
                        score[1] = { disabled: val[2] === "1", value: [val[0], val[1]] };
                    } else {
                        score[1] = { disabled: true, value: [0, 10] };
                    }
                } else if (copt === "r3:") {
                    let val = ccontent.split("|");
                    if (val.length >= 3) {
                        score[2] = { disabled: val[2] === "1", value: [val[0], val[1]] };
                    } else {
                        score[2] = { disabled: true, value: [0, 10] };
                    }
                } else if (copt === "r4:") {
                    let val = ccontent.split("|");
                    if (val.length >= 3) {
                        score[3] = { disabled: val[2] === "1", value: [val[0], val[1]] };
                    } else {
                        score[3] = { disabled: true, value: [0, 10] };
                    }
                } else if (copt === "r5:") {
                    let val = ccontent.split("|");
                    if (val.length >= 3) {
                        score[4] = { disabled: val[2] === "1", value: [val[0], val[1]] };
                    } else {
                        score[4] = { disabled: true, value: [0, 10] };
                    }
                } else if (copt === "r6:") {
                    let val = ccontent.split("|");
                    if (val.length >= 3) {
                        score[5] = { disabled: val[2] === "1", value: [val[0], val[1]] };
                    } else {
                        score[5] = { disabled: true, value: [0, 10] };
                    }
                } else if (copt.substr(0, 1) === "v") {
                    let val = ccontent.split("|");

                    let key = this.advancedLookup["ca" + val[0]].type;
                    let pos = this.advancedLookup["ca" + val[0]].pos;
                    let type = Config.criteria.advanced[key][pos].type;

                    let advanced = {
                        selected: true,
                        option: 0,
                        option2: 0,
                        lower: -9999999999,
                        upper: 9999999999,
                        enabled: true,
                        refreshSnap: true,
                        monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                    }
                    if (key === "consensus" && i === 28) {
                        advanced = {
                            selected: true,
                            option: 0,
                            option2: 0,
                            lower: 1,
                            upper: 5,
                            enabled: true,
                            refreshSnap: true,
                            monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                        };
                    }
                    advanced.enabled = (val[4] === "1");
                    if (type === 1) {
                        advanced.lower = val[2];
                        advanced.upper = val[3];
                    } else if (type === 2 || type === 3 || type === 7) {
                        for (let i = 0; i < Config.criteria.advanced[key][pos].optvalue.length; i++) {
                            if (Config.criteria.advanced[key][pos].optvalue[i] === val[1]) {
                                advanced.option = i;
                                break;
                            }
                        }
                        advanced.lower = val[2];
                        advanced.upper = val[3];
                    } else if (type === 5) {
                        let tmpval = val[1].split("*");
                        for (let i = 0; i < Config.criteria.advanced[key][pos].optvalue2.length; i++) {
                            if (Config.criteria.advanced[key][pos].optvalue2[i] === tmpval[0]) {
                                advanced.option2 = i;
                                break;
                            }
                        }
                        for (let i = 0; i < Config.criteria.advanced[key][pos].optvalue.length; i++) {
                            if (Config.criteria.advanced[key][pos].optvalue[i] === tmpval[1]) {
                                advanced.option = i;
                                break;
                            }
                        }
                        advanced.lower = val[2];
                        advanced.upper = val[3];
                    } else if (type === 4) {
                        for (let i = 0; i < Config.criteria.advanced[key][pos].optvalue.length; i++) {
                            if (Config.criteria.advanced[key][pos].optvalue[i] === val[2]) {
                                advanced.option = i;
                                break;
                            }
                        }
                        for (let i = 0; i < Config.criteria.advanced[key][pos].optvalue2.length; i++) {
                            if (Config.criteria.advanced[key][pos].optvalue2[i] === val[3]) {
                                advanced.option2 = i;
                                break;
                            }
                        }
                    } else if (type === 6) {
                        for (let i = 0; i < Config.criteria.advanced[key][pos].optvalue.length; i++) {
                            if (Config.criteria.advanced[key][pos].optvalue[i] === val[2]) {
                                advanced.option = i;
                                break;
                            }
                        }
                        let tmpmonthchecked = val[2].split("m");
                        for (let i = 0; i < tmpmonthchecked.length; i++) {
                            if (tmpmonthchecked[i] === "") {
                                break;
                            }
                            //  console.log("tmpmonthchecked:" + tmpmonthchecked[i]);
                            advanced.monthChecked[tmpmonthchecked[i] - 1] = true;
                        }
                        advanced.lower = val[2];
                        advanced.upper = 0;
                    }
                    this.criteria.advanced[key][pos] = advanced;
                    aq.push({ key, i: pos })
                }
            }

            this.criteria.market = market;
            this.criteria.capsize = capsize;
            this.criteria.index = index;
            this.criteria.sector = sector;
            this.criteria.nisa = nisa;
            this.criteria.bullbear = bullbear;
            this.criteria.score = score;
            this.criteria.investamt = investamt;
            this.setState({ criteria: this.criteria }, () => {
                this.setState({ criteriaSnap: JSON.parse(JSON.stringify(this.state.criteria)) });
                // this.getScreenerResult(true);
                this.setState({ advancedQueue: aq });
                this.setState({ pageno: 1, sortby: sortby, sortorder: sortorder, savebtnStyleName: "screenersavedbtn", savebtnName: "Myスクリーナーに登録済", presetSelected: id }, () => {
                    this.setState({ fromPreset: true });
                    this.handleChange(true, true, this.state.fromPreset);
                });
            }
            );


        });
    }
    handleSortResult = (col) => {
        let sortorder = this.state.sortorder;
        if (this.state.sortby === col) {
            if (sortorder === "asc") {
                sortorder = "desc";
            } else {
                sortorder = "asc";
            }
        } else {
            sortorder = "asc";
        }
        this.setState({ sortby: col, sortorder }, () => { this.getScreenerResult() });
    }
    handleDownloadCSV = () => {
        axios({
            url: 'data/download_csv?token=' + this.token + '&cs=' + this.getCriteraRequestString() + '&sortid=' + this.state.sortby + '&issortasc=' + (this.state.sortorder === "asc" ? true : false),
            method: 'GET',
            responseType: 'text', // important
        }).then((response) => {
            // //console.log(response);

            if (navigator.msSaveOrOpenBlob) {
                navigator.msSaveOrOpenBlob(new Blob(["\uFEFF" + response.data]), "screener_result.csv");
            } else {
                const url = window.URL.createObjectURL(new Blob(["\uFEFF" + response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'screener_result.csv'); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        });
    }
    getNumberOfSelectedItem = () => {
        let type = [];
        Object.keys(Config.criteria.advanced).forEach((key) => {
            type.push(key);
        });
        let count = 0;
        for (let i = 0; i < type.length; i++) {
            for (let j = 0; j < this.state.criteria.advanced[type[i]].length; j++) {
                if (this.state.criteria.advanced[type[i]][j].selected) {
                    count++;
                }
            }
        }
        return count;
    }
    getMarketRequestString = () => {
        let requeststr = "m:";
        for (let i = 0; i < this.state.criteria.market.length; i++) {
            if (this.state.criteria.market[i]) {
                if(Config.criteria.market[i])
                requeststr += Config.criteria.market[i].id;
            }
        }
        return requeststr;
    }
    getCapSizeRequestString = () => {
        let requeststr = "c:";
        for (let i = 0; i < this.state.criteria.capsize.length; i++) {
            if (this.state.criteria.capsize[i]) {
                requeststr += Config.criteria.capsize[i].id;
            }
        }
        return requeststr;
    }
    getIndexRequestString = () => {
        let requeststr = "i:";
        for (let i = 0; i < this.state.criteria.index.length; i++) {
            if (this.state.criteria.index[i]) {
                requeststr += Config.criteria.index[i].id;
            }
        }
        return requeststr;
    }
    getNisaRequestString = () => {
        let requeststr = "n:";
        for (let i = 0; i < this.state.criteria.nisa.length; i++) {
            if (this.state.criteria.nisa[i]) {
                requeststr += Config.criteria.nisa[i].id;
            }
        }
        return requeststr;
    }
    getBullbearRequestString = () => {
        let requeststr = "b:";
        for (let i = 0; i < this.state.criteria.bullbear.length; i++) {
            if (this.state.criteria.bullbear[i]) {
                requeststr += Config.criteria.bullbear[i].id;
            }
        }
        return requeststr;
    }
    getInvestAmtRequestString = () => {
        let requeststr = "a:";
        if (this.state.criteria.investamt[0] > -1 || this.state.criteria.investamt[1] > -1) {
            requeststr += "0|"
        } else {
            requeststr += "1|"
        }
        if (this.state.criteria.investamt[0] > -1) {
            requeststr += this.state.criteria.investamt[0] + "|";
        } else {
            requeststr += "0|";
        }
        if (this.state.criteria.investamt[1] > -1) {
            requeststr += this.state.criteria.investamt[1];
        } else {
            requeststr += "0";
        }
        return requeststr;
    }
    getSectorRequestString = () => {
        let requeststr = "s:";
        for (let i = 0; i < this.state.criteria.sector.length; i++) {
            if (this.state.criteria.sector[i]) {
                requeststr += Config.criteria.sector[i].id;
            }
        }
        return requeststr + "ONN1";
    }
    getCompanyScoreRequestString = () => {
        let requeststr = "";
        for (let i = 0; i < this.state.criteria.score.length; i++) {
            if (requeststr.length > 0) {
                requeststr += ",";
            }
            requeststr += "r" + (i + 1) + ":" + this.state.criteria.score[i].value[0] + "|" + this.state.criteria.score[i].value[1] + "|" + (this.state.criteria.score[i].disabled ? "1" : "0");
        }
        return requeststr;
    }
    getAdvCriteriaRequestString = () => {
        let requeststr = "";
        let advcnt = -1;
        //console.log("sortby:" + this.state.sortby + ",sortorder:" + this.state.sortorder);

        for (let n = 0; n < this.state.advancedQueue.length; n++) {
            let key = this.state.advancedQueue[n].key;
            let i = this.state.advancedQueue[n].i;
            if (n === 0) advcnt = 0;
            // Object.keys(Config.criteria.advanced).forEach((key) => {
            // for (let i=0; i<Config.criteria.advanced[key].length; i++) {
            if (this.state.criteria.advanced[key][i].selected && this.state.criteria.advanced[key][i].enabled) {
                if (requeststr.length > 0) {
                    requeststr += ",";
                }
                requeststr += "v" + advcnt + ":" + Config.criteria.advanced[key][i].id + "|" + ((Config.criteria.advanced[key][i].type === 2 || Config.criteria.advanced[key][i].type === 3 || Config.criteria.advanced[key][i].type === 7) ? Config.criteria.advanced[key][i].optvalue[this.state.criteria.advanced[key][i].option] : (Config.criteria.advanced[key][i].type === 5 ? (Config.criteria.advanced[key][i].optvalue2[this.state.criteria.advanced[key][i].option2] + "*" + Config.criteria.advanced[key][i].optvalue[this.state.criteria.advanced[key][i].option]) : "0")) + "|" + ((Config.criteria.advanced[key][i].type === 4) ? Config.criteria.advanced[key][i].optvalue[this.state.criteria.advanced[key][i].option] : this.state.criteria.advanced[key][i].lower) + "|" + (Config.criteria.advanced[key][i].type === 6 ? Config.criteria.advanced[key][i].options[this.state.criteria.advanced[key][i].option] : (Config.criteria.advanced[key][i].type === 4 ? Config.criteria.advanced[key][i].optvalue2[this.state.criteria.advanced[key][i].option2] : this.state.criteria.advanced[key][i].upper)) + "|" + (this.state.criteria.advanced[key][i].enabled ? "1" : "0");
                advcnt++;
            }
            // }
            // });
        }

        // //console.log("advcnt:" + advcnt + ",sortby substring:" + this.state.sortby.substring(1,2));
        if (this.state.sortby.substring(1, 2) >= advcnt && advcnt > 0) {
            // //console.log("advcnt1:" + (advcnt-1) + ",sortby substring1:" + this.state.sortby.substring(1,2));
            this.sortBy = "a" + (advcnt - 1);
            this.setState({ sortby: "a" + (advcnt - 1) });
        }
        if (advcnt <= 0) {
            this.sortBy = "c";
            this.setState({ sortby: "c" });
        }
        return requeststr;

    }
    getCriteraRequestString = () => {
        let requeststr = "";
        requeststr += this.getMarketRequestString() + "," + this.getCapSizeRequestString() + "," + this.getIndexRequestString()+ "," + this.getNisaRequestString()+ "," + this.getBullbearRequestString() + "," + this.getSectorRequestString() + "," + this.getInvestAmtRequestString() + "," + this.getCompanyScoreRequestString() + "," + this.getAdvCriteriaRequestString();
        // //console.log(requeststr);
        return requeststr;
    }
    getScreenerResult = (refreshSnap, keepPageno, fromPreset) => {
        //console.log("3333:"+this.state.fromPreset);
        // if(this.state.savedShowSearchPage)return;
        cancel && cancel();
        this.setState({ isLoading: true });
        this.sortBy = this.state.sortby;
        let pageno = 1;
        if (keepPageno) {
            pageno = this.state.pageno;
        } else {
            this.setState({ pageno });
        }

        let tmpcstring = this.getCriteraRequestString();

        if (this.state.fromPreset) {
            this.setState({ presetString: tmpcstring });
        }

        axios.get("data/screener", {
            params: {
                cs: this.getCriteraRequestString(),
                sortid: this.sortBy,
                issortasc: this.state.sortorder === "asc" ? true : false,
                rec_per_page: this.state.recperpage,
                page: pageno,
                countOnly: false,
                token: this.token
            },
            cancelToken: new CancelToken((c) => {
                cancel = c;
            })
        })
            .then(
                (result) => {
                    // //console.log(result);
                    if (result.data.count === -1) {
                        result.data.count = 0;
                    }
                    if (result.data.count >= 0) {
                        result.data.update = this.timeStamp2String(result.data.update)
                    }
                    this.setState({
                        result: result.data,
                        isLoading: false
                    });
                    if (refreshSnap) {
                        this.setState({
                            resultSnap: JSON.parse(JSON.stringify(result.data))
                        });
                    }
                    this.setState({ acSelectedCount: this.getNumberOfSelectedItem() });
                    if (this.state.fromPreset || this.state.presetString === tmpcstring) {
                        this.setState({ savebtnStyleName: "screenersavedbtn", savebtnName: "Myスクリーナーに登録済" });
                        this.setState({ fromPreset: false });
                    } else {
                        this.setState({ savebtnStyleName: "screenersavebtn", savebtnName: "Myスクリーナーに保存" });
                        this.setState({ fromPreset: false, presetString: "" });
                    }

                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                }
            )
    }
    addAdvancedQueue = (advqobj) => {
        let aq = this.state.advancedQueue;
        aq.push(advqobj);
        this.setState({ advancedQueue: aq });
    }
    handleDragEnd = (aq, sortby) => {
        //  console.log(aq)
        this.setState({ advancedQueue: aq, sortby: sortby }, () => { this.getScreenerResult(true); });
    }
    componentDidMount() {
        // this.getScreenerResult(true);
    }
    //年月日
    timeStamp2String = (time) => {
        var datetime = new Date();
        datetime.setTime(time);
        var year = datetime.getFullYear();
        var month = datetime.getMonth() + 1;
        var date = datetime.getDate();
        var hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
        var minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
        // var hour =;
        return year + "年" + month + "月" + date + "日 " + hour + ":" + minute;
    }
    _onMouseMove(e) {
        // this.setState({ x: e.screenX, y: e.screenY });
        // //console.log( "X:"+this.state.x);
        // //console.log( "Y"+this.state.y);
    }
    cancelPresetSelected = () => {
        this.setState({ presetSelected: "" });
    }
    clearAll = (from) => {
        this.setState({ sortby: "c", sortorder: "asc" });
        let market = [];
        this.marketLookup = [];
        for (let i = 0; i < Config.criteria.market.length; i++) {
            market[i] = true;
            this.marketLookup[Config.criteria.market[i].resultid] = i;
        }
        let capsize = [];
        this.capsizeLookup = [];
        for (let i = 0; i < Config.criteria.capsize.length; i++) {
            capsize[i] = true;
            this.capsizeLookup[Config.criteria.capsize[i].resultid] = i;
        }
        let index = [];
        this.indexLookup = [];
        for (let i = 0; i < Config.criteria.index.length; i++) {
            index[i] = false;
            this.indexLookup[Config.criteria.index[i].resultid] = i;
        }
        let sector = [];
        this.sectorLookup = [];
        for (let i = 0; i < Config.criteria.sector.length; i++) {
            sector[i] = true;
            this.sectorLookup["cs" + Config.criteria.sector[i].id] = i;
        }
        let nisa = [];
        this.nisaLookup = [];
        for (let i = 0; i < Config.criteria.nisa.length; i++) {
            nisa[i] = false;
            this.nisaLookup[Config.criteria.nisa[i].resultid] = i;
        }
        let bullbear = [];
        this.bullbearLookup = [];
        for (let i = 0; i < Config.criteria.bullbear.length; i++) {
            bullbear[i] = false;
            this.bullbearLookup[Config.criteria.bullbear[i].resultid] = i;
        }
        let score = [];
        for (let i = 0; i < Config.criteria.score.length; i++) {
            score[i] = { disabled: true, value: [0, 10] };
        }
        let investamt = [];
        let advanced = [];
        this.advancedLookup = [];
        this.advancedOptvalueLookup = [];
        this.advancedOptvalue2Lookup = [];
        Object.keys(Config.criteria.advanced).forEach((key) => {
            advanced[key] = [];
            for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                advanced[key][i] = {
                    selected: false,
                    option: 0,
                    option2: 0,
                    lower: -9999999999,
                    upper: 9999999999,
                    enabled: true,
                    refreshSnap: true,
                    monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                };
                if (key === "consensus" && i === 28) {
                    advanced[key][i] = {
                        selected: false,
                        option: 0,
                        option2: 0,
                        lower: 1,
                        upper: 5,
                        enabled: true,
                        refreshSnap: true,
                        monthChecked: [false, false, false, false, false, false, false, false, false, false, false, false]
                    };
                }
                this.advancedLookup["ca" + Config.criteria.advanced[key][i].id] = { type: key, pos: i };

                if (Config.criteria.advanced[key][i].optvalue) {
                    this.advancedOptvalueLookup["ca" + Config.criteria.advanced[key][i].id] = [];
                    for (let j = 0; j < Config.criteria.advanced[key][i].optvalue.length; j++) {
                        this.advancedOptvalueLookup["ca" + Config.criteria.advanced[key][i].id][Config.criteria.advanced[key][i].optvalue[j]] = j;
                    }
                }
                if (Config.criteria.advanced[key][i].optvalue2) {
                    this.advancedOptvalue2Lookup["ca" + Config.criteria.advanced[key][i].id] = []
                    for (let j = 0; j < Config.criteria.advanced[key][i].optvalue2.length; j++) {
                        this.advancedOptvalue2Lookup["ca" + Config.criteria.advanced[key][i].id][Config.criteria.advanced[key][i].optvalue2[j]] = j;
                    }
                }
            }
        });

        this.setState({
            criteria: {
                market,
                capsize,
                sector,
                index,
                score,
                nisa,
                bullbear,
                advanced: {
                    financial: advanced["financial"],
                    consensus: advanced["consensus"],
                    priceperf: advanced["priceperf"],
                    technical: advanced["technical"],
                    other: advanced["other"]
                },
                investamt
            },
            criteriaSnap: {
                market,
                capsize,
                sector: [...sector],
                index,
                score: [...score],
                nisa,
                bullbear,
                advanced: {
                    financial: [...advanced["financial"]],
                    consensus: [...advanced["consensus"]],
                    priceperf: [...advanced["priceperf"]],
                    technical: [...advanced["technical"]],
                    other: [...advanced["other"]]
                },
                investamt
            }
        }
        );

        this.setState({ criteriaSnap: JSON.parse(JSON.stringify(this.state.criteria)), presetSelected: "all", presetString: "" }, () => {
            if (from === "preset") {
                this.handleChange(true);
            } else {
                this.getScreenerResult(this.state.criteriaSnap);
            }

        });




        // this.getScreenerResult(this.state.criteriaSnap);
        // this.getScreenerResult = debounce(this.getScreenerResult,500);
    }
    handlePresetArrow = (leftArrowSelected) => {
        this.setState({ leftArrowSelected: leftArrowSelected });
    }
    handleScrollXPosChange = (scrollXPos) => {
        this.setState({ scrollXPos });
    }
    getCookieExpiresDate = () => {
        const expires = new Date()
        expires.setTime((Date.now() + 1000 * 60 * 60 * 24 * 30))
        return expires;
    }
    render() {
        return (
            <div className={this.state.appId === "Hyper" ? "Screener hyper" : "Screener"} onMouseMove={this._onMouseMove.bind(this)}>
                <PresetWidget token={this.token} clearAll={this.clearAll} scrollXPos={this.state.scrollXPos} handleScrollXPosChange={this.handleScrollXPosChange} leftArrowSelected={this.state.leftArrowSelected} handlePresetArrow={this.handlePresetArrow} default={this.preset} data={this.state.myscreener} data2={this.state.myscreenermemo} onLoad={this.handlePresetScreenerLoading} onLoadCustom={this.handleCustomScreenerLoading} presetSelected={this.state.presetSelected} section={this.state.section} handleSection={this.handleSection} />
                {!this.state.showSearchResult &&
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: '-7.5px' }}>
                        <WidgetTitle content="検索条件選択" />
                        <CriteriaListWidget fristLogin={this.state.fristLogin} handlePopupChange={this.handlePopupChange} showSearchResult={this.state.showSearchResult} handleChange={this.handleChange} uiHidden={this.state.myScrResearchHidden} savebtnStyleName={this.state.savebtnStyleName} savebtnName={this.state.savebtnName} />
                    </div>

                }
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', marginTop: '7.5px' }}>
                    <div className="resultinfo" hidden={this.state.myScrResearchHidden}>該当銘柄 <span className="countTotel">{this.state.result.count}</span> 件</div>
                    <div className="clearAll" hidden={this.state.myScrResearchHidden} onClick={this.clearAll}>全条件をクリア</div>

                </div>
                <div style={{ clear: 'both' }} />


                <div style={{ clear: 'both' }} />
                {this.state.showSearchResult &&
                    <div className="resultpane" style={{ display: this.state.showSearchResult ? "flex" : "none", justifyContent: "space-between" }}>
                        <CriteriaMiniWidget fromPreset={this.state.fromPreset} acSelectedCount={this.state.acSelectedCount} handleSelectionBoxChange={this.handleSelectionBoxChange} handleSelectAllMarket={this.handleSelectAllMarket} isSelectAllMarketChecked={this.isSelectAllMarketChecked} handlePopupChange={this.handlePopupChange} handleInvestAmtChange={this.handleInvestAmtChange} handleCriteriaBoxChange={this.handleCriteriaBoxChange} addAdvancedQueue={this.addAdvancedQueue} handleDragEnd={this.handleDragEnd} advancedQueue={this.state.advancedQueue} criteria={this.state.criteria} data={this.state.result.criteria_result_counts} sortby={this.state.sortby} token={this.token} />
                        <ResultWidget appId={this.state.appId} fromPreset={this.state.fromPreset} clearAll={this.clearAll} criteria={this.state.criteria} data={this.state.result} advancedQueue={this.state.advancedQueue} isLoading={this.state.isLoading} recperpage={this.state.recperpage} pageno={this.state.pageno} sortby={this.state.sortby} sortorder={this.state.sortorder} onRecPerPageChange={this.handleRecPerPageChange} onPageChange={this.handlePageChange} onSort={this.handleSortResult} onDownloadCSV={this.handleDownloadCSV} handlePopupChange={this.handlePopupChange} handleCompInfoPopupChange={this.handleCompInfoPopupChange} showSearchResult={this.state.showSearchResult} handleChange={this.handleChange} uiHidden={this.state.myScrResultHidden} savebtnStyleName={this.state.savebtnStyleName} savebtnName={this.state.savebtnName} token={this.token} />
                    </div>
                }
                {!this.state.showSearchResult &&
                    <div className="criteriapane" style={{ display: this.state.showSearchResult ? "none" : "block", marginTop: '15px' }}>
                        <CriteriaWidget fromPreset={this.state.fromPreset} clearAll={this.clearAll} showErrMsg={this.state.showErrMsg} handleSelectionBoxChange={this.handleSelectionBoxChange} handleCriteriaBoxChange={this.handleCriteriaBoxChange} handleSelectAllMarket={this.handleSelectAllMarket} isSelectAllMarketChecked={this.isSelectAllMarketChecked} handleSelectAllSector={this.handleSelectAllSector} isSelectAllSectorChecked={this.isSelectAllSectorChecked} handleScoreBoxChange={this.handleScoreBoxChange} handleInvestAmtChange={this.handleInvestAmtChange} handleSearch={this.handleChange} criteria={this.state.criteria} data={this.state.result} token={this.token} />
                    </div>
                }


                <div className={"App-Popup"}>
                    {this.state.showPopup === "sector" &&
                        <SectorPopup appId={this.state.appId} closePopup={this.closePopupHandler} submit={this.handleSectorSubmit} sector={this.state.criteria.sector} data={this.state.result.criteria_result_counts} />
                    }
                    {this.state.showPopup === "companyscore" &&
                        <CompanyScorePopup appId={this.state.appId} closePopup={this.closePopupHandler} submit={this.handleScoreSubmit} score={this.state.criteria.score} />
                    }
                    {this.state.showPopup === "advcriteria" &&
                        <AdvCriteriaPopup appId={this.state.appId} closePopup={this.closePopupHandler} submit={this.handleAdvCriteriaSubmit} criteria={this.state.criteria.advanced} />
                    }
                    {this.state.showPopup === "myscreener" &&
                        <MyScreenerPopup appId={this.state.appId} closePopup={this.closePopupHandler} onSaveScreener={this.handleSaveScreener} data={this.state.myscreener} data2={this.state.myscreenermemo} presetSelected={this.state.presetSelected} />
                    }
                    {this.state.showPopup === "companyinfo" &&
                        <CompanyInfoPopup appId={this.state.appId} closePopup={this.closePopupHandler} submit={this.handleScoreSubmit} score={this.state.criteria.score} compInfo={this.state.compInfo} />
                    }
                </div>
                <a className='refinitivlogo' href="disclaimer" target="_blank">
                    <img src={refinitivlogo} width="150" alt="Refinitiv" /></a>
            </div>
        )
    }
}